
import React, { Component } from 'react';
import Link from '../../../../../components/ZUILib/Link';
import TextInput from '../../../../../components/ZUILib/TextInput';
import Monedero from './monedero';
import InputButton from '../../../../../components/ZUILib/InputButton';
import { calculateCommision } from '../../actions';
import commonUtil from '../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
class MonederoForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isContinueButtonDisable: true,
      info: {
        currentStep: 3,
        total: 4,
      },
      walletLengthError: false,
    };
  }

  onNextStepClick = () => {
    const submitTransferenceObj = this.monedero.getFormData();
    let walletType = '';
    const totalAmountForCommission = (+this.props.submitTransferenceData.walletOrEmployeeCardAmount + +this.props.submitTransferenceData.bonusAmount).toString();
    if (submitTransferenceObj.walletOrEmployeeIdentifierId) {
      walletType = '0';
    } else {
      walletType = submitTransferenceObj.walletType;
    }
    calculateCommision(this.props.submitTransferenceData.eventId, '', walletType, totalAmountForCommission, submitTransferenceObj.walletOrEmployeeIdentifierId)
      .then((data) => {
        if (data.body.status.status === 'success') {
          const transactionInfo = data.body.transactionInfo;
          if (transactionInfo.commissionToWallet) {
            const submitTransferenceData = {
              ...submitTransferenceObj,
              totalAmount_View: transactionInfo.totalAmountToWallet,
              commissionValue: transactionInfo.commissionFeeToWallet,
              walletCommissionAmount: transactionInfo.commissionToWallet,
              paymentMode: 'MonederoForm',
            };
            if ((this.monedero.state.walletNumber_mltpc && this.monedero.state.walletNumber_mltpc.length > 0 && this.monedero.state.walletNumber_mltpc && this.monedero.state.walletNumber_mltpc.length < 16) ||
              (this.monedero.state.walletNumber_mmdr && this.monedero.state.walletNumber_mmdr.length > 0 && this.monedero.state.walletNumber_mmdr && this.monedero.state.walletNumber_mmdr.length < 13)) {
              this.setState({ walletLengthError: true });
            } else {
              this.setState({ walletLengthError: false });
              this.props.submitTransferenceDataFunction(submitTransferenceData);
            }
            // this.props.submitTransferenceDataFunction(submitTransferenceData);
          }
        }
      })
      .catch((e) => {
        console.log(e); // console required
      });
  }
  onBackClick = () => {
    this.props.onBackClick('MonederoForm');
  }
  disableContinueButton = (isDisable) => {
    this.setState({ isContinueButtonDisable: isDisable });
  }

  render() {
    const walletOrEmployeeCardAmount = this.props.submitTransferenceData && this.props.submitTransferenceData.walletOrEmployeeCardAmount;
    const prevButton = {
      name: 'Regresar',
      type: 'button',
      value: 'Regresar',
      autoFocus: false,
      style: 'btnSecondaryAction size-Large',
      onClickHandler: this.onBackClick,
      beforeIconClass: 'iconLeft icon-flecha_light_izq',
    };
    const nextStep = {
      name: 'Siguiente paso',
      type: 'button',
      value: 'Siguiente paso',
      autoFocus: false,
      style: 'btnPrimary size-Large',
      onClickHandler: this.onNextStepClick,
      id: 'nextStep',
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      disabled: this.state.isContinueButtonDisable ? 'disabled' : '',
    };
    const nextStepLink = {
      id: 'nextStepLink',
      text: 'Siguiente paso',
      children: 'Siguiente paso',
      href: '',
      cssClass: this.state.isContinueButtonDisable ? 'btnPrimary size-Full hiddenStyle' : 'btnPrimary size-Full',
      onClickHandler: this.onNextStepClick,
    };
    const RegresarLink = {
      text: 'Regresar',
      children: 'Regresar',
      href: '',
      cssClass: 'btnSecondaryAction size-Full',
      onClickHandler: this.onBackClick,
    };
    const errorAncher = {
      cssClass: 'icon-tache2',
      onClickHandler: () => { this.setState({ walletLengthError: null }); },
    };
    return (
      <React.Fragment>
        {channel === constChannels.WAP ?
          <div className="col-xs-12 innerOptions innerDataDeposit">
            <p>Datos de depósito a monedero</p>
            <p>* Campos obligatorios</p>
            {this.state.walletLengthError ?
              <div>
                <br />
                <div className="alertError">
                  <i className="icon-tache2" />
                  <p>{'Numero de monedero no valido. Favor de ingresar nuevamente'}</p>
                  <Link linkJSON={errorAncher} />
                </div>
              </div>
              : null}
            <div className="formBlock">
              <TextInput
                parentClassName="materialStyle"
                className="inputMaterial"
                labelClassName="placeHolderMaterial"
                star="*"
                label="Cantidad de deposito"
                required
                maxlength="16"
                disabled
                value={commonUtil.getCurrency(walletOrEmployeeCardAmount)}
                ref={txt => this.walletNumber_mltpc_new = txt}
              />
            </div>
            <div className="row">
              <div className="col-md-12 col-sm-12 depositForm">
                <div className="margin20">
                  <Monedero ref={monedero => (this.monedero = monedero)} transferenceData={this.props.transference} disableContinueButton={this.disableContinueButton} transferenceMethodTypeClosure lables={this.props.lables} eventId={this.props.eventId} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 innerButtons">
                <p className="text15w"><span>Fecha de operación&nbsp;&nbsp;</span>{this.props.submitTransferenceData && commonUtil.formatDate(this.props.submitTransferenceData.transferDate, 'monthName')}</p>
                <Link linkJSON={nextStepLink}>Siguiente paso<i className="iconRight icon-flecha_lightsvg_derecha" aria-hidden="true" data-original-title title /></Link>
                <Link linkJSON={RegresarLink} ><i className="iconLeft icon-flecha_light_izq" aria-hidden="true" data-original-title title />Regresar</Link>
              </div>
            </div>
          </div>
          :
          <div className="panel">
            <div className="panel-heading row disable" id="step2-header">
              <div className="col-md-12 col-sm-12">
                <hr />
                <div className="fa-stack text-center"><span>3</span></div>
                <h4>Datos de depósito a monedero</h4>
              </div>
            </div>
            <div className="panel-collapse collapse" aria-expanded="true">
              <div className="panel-body row">
                {this.state.walletLengthError ?
                  <div className="col-md-12 col-sm-12 depositForm">
                    <div className="alertError">
                      <i className="icon-tache2" />
                      <p>{'Numero de monedero no valido. Favor de ingresar nuevamente'}</p>
                      <Link linkJSON={errorAncher} />
                    </div>
                    <br />
                  </div>
                  : null}
                <div className="col-md-12 col-sm-12 depositForm">
                  <div className="col-md-2 col-sm-2"><small>&nbsp;Cantidad de depósito</small>
                    <div className="quantityBlock bankStyle"><strong className="quantity">{commonUtil.getCurrency(walletOrEmployeeCardAmount)}</strong></div>
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 depositForm">
                  <hr />
                  <div className="margin20">
                    <Monedero ref={monedero => (this.monedero = monedero)} transferenceData={this.props.transference} disableContinueButton={this.disableContinueButton} transferenceMethodTypeClosure />
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 depositForm">
                  <div className="innerButtons">
                    <div className="col-sm-6 col-md-6">
                      <InputButton buttonAttr={prevButton} />
                    </div>
                    <div className="col-sm-6 col-md-6">
                      <InputButton buttonAttr={nextStep} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >}
      </React.Fragment>
    );
  }
}

export default MonederoForm;
